module.exports = __webpack_public_path__ + "static/img/wireframe.58ab65a6.jpg";